/* eslint-disable react/forbid-elements, max-lines -- TODO [CU-86c99qfh1]: extract remaining inline HTML to feature components; route grew as inventory view was refactored to MediaInventoryResultsView */
/* eslint-disable complexity -- TODO [CU-86c99qfh1]: extract route quick-add orchestration into feature modules */
/* eslint-disable max-lines-per-function -- TODO [CU-86c99qfh1]: extract route quick-add orchestration into feature modules + calendar-offer-bound-reservations */
import type { ResolvedOffer } from '@ooh/screens';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  buildAvailabilityEnquiryHref,
  type CellState,
  type MultiSelectCellRef,
  computeMultiSelectRectangle,
  isShiftSelectableState,
  InspectPopover,
  resolveDominantEntry,
  useReservationPermissions,
  useUpgradeHard,
  useCloseSale,
  useCancelReservation,
  useForceRelease,
  buildRichAvailabilityColumns,
  buildLoadMoreColumn,
  GRANULARITY_COL_WIDTH,
  RICH_AVAILABILITY_CELL_TESTID_PREFIX,
  AvailabilitySubToolbar,
  buildPeriods,
  buildAvailabilityLegendItems,
  buildInspectQuickActionHandlers,
  buildInventoryAvailabilityGrid,
  resolveAvailabilityMultiSelectCell,
  resolveFreeCellDateRange,
  resolveSelectedMediaUnitIds,
  type InventoryAvailabilityPeriod,
  normalizeClientList,
  DetailPhotoLightbox,
  QuickAddOfferPicker,
  QuickAddOfferPickerCompactTrigger,
  buildQuickAddPickerLabels,
  getInitialSelectedDraftId,
  resolvePreselectedOfferId,
  INVENTORY_QUICK_ADD_PICKER_BASE_KEY,
  buildAvailabilityWindow,
  buildQueueJoinPanelLabels,
  buildQueueJoinSection,
  resolveCellQueueWindowContext,
  useCellQueueJoin,
  useSelectBatchResults,
  useSelectQueueJoin,
  useQueueClientOptions,
  useCalendarOfferPicker,
  useQuickAddPickerData,
  useQueueOfferOptions,
} from '@ooh/screens';
import {
  createFileRoute,
  useRouter,
  useNavigate,
  useSearch,
  useRouteContext,
} from '@tanstack/react-router';
import { PageTitleContext } from '../__root';
import { BulkActionToolbar } from '@ooh/ui/components/bulk-action-toolbar';
import type { BulkAction } from '@ooh/ui/components/bulk-action-toolbar';
import { FilterPanel, DateRangePill, PillWrapper } from '@ooh/ui/components/filter-panel';
import { BooleanFilterPill } from '@ooh/ui/components/boolean-filter-pill';
import { SaveCampaignDialog } from '@ooh/ui/components/save-campaign-dialog';
import { Button } from '@ooh/ui/components/button';
import {
  EXCLUDABLE_FILTER_FIELDS,
  type ExcludableFilterField,
  BULK_DOWNLOAD_MAX_UNITS,
  SUPPLIER_PHOTO_ZIP_MAX_UNITS,
} from '@ooh/contracts';
import { InventorySearchInput } from '../../components/inventory-search-input';
import { RowDetailLink } from '../../components/row-detail-link';
import {
  CatalogOpenOnMapAction,
  COORDINATE_SEARCH_ZOOM,
  parseCoordinates,
  useMapCoordinateSearchEnabled,
} from '../../features/map-search';
import { TooltipProvider } from '@ooh/ui/components/tooltip';
import { useQuickAddPipeline } from '../../features/media-units/components/use-quick-add-pipeline';
import { NearPoiFilterSection } from '../../features/pois/components/near-poi-filter-section';
import { resolveCanImport } from '../../features/media-units/lib/resolve-can-import';
import { buildMapNavigationSearch } from '../../features/media-units/lib/build-map-navigation-search';
import {
  LoadingSkeleton,
  UnauthorizedState,
} from '../../features/media-units/components/page-states';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMediaUnitsPage } from '../../features/media-units/hooks/use-media-units-page';
import { useInventoryViewState } from '../../features/media-units/hooks/use-inventory-view-state';
import { validateMediaUnitsSearch } from '../../features/media-units/lib/validate-search';
import { encodeCatalogSearch } from '../../lib/catalog-return-context';
import { resolveEmptyMessage } from '../../features/media-units/lib/resolve-empty-message';
import { NEAR_POI_FILTER_ID } from '../../lib/filter-config';
import { isPoiFilterActive } from '../../hooks/use-poi-filter-params';
import { DataTable } from '@ooh/ui/components/data-table';
import { InventoryToolbarRow } from '../../features/media-units/components/inventory-toolbar-row';
import { useAvailabilityLoadMoreWindow } from '../../features/media-units/hooks/use-availability-load-more-window';
import { UnifiedSelectPopover, type UnifiedSelectCellResolution } from '@ooh/screens';
import { useMultiSelectAnchor } from '@ooh/screens';
import { useHasPermission } from '../../hooks/use-has-permission';
import { useHasNarrowedVisibility } from '../../hooks/use-has-narrowed-visibility';
import { useHasWildcardPermission } from '../../hooks/use-has-wildcard-permission';
import { useClientsList } from '../../features/clients/api';
import { useCampaignNumberPreview, useOfferSalesUsers } from '../../features/offers/api';
import type { CampaignNumberPreviewQuery, Client, MediaUnitListItem } from '@ooh/contracts';
import {
  mediaUnitAvailabilityQuery,
  mapAvailabilityResponseToOccupancy,
  mapAvailabilityResponseToEntriesGrid,
  AVAILABILITY_CALENDAR_CAPABILITY,
} from '../../features/media-units/api/queries';
import { MEDIA_UNIT_AVAILABILITY_KEY_PREFIX } from '../../lib/query-keys';
import { BulkDownloadConfirmDialog } from '../../features/media-units/components/bulk-download-confirm-dialog';
import { useBulkDownloadSpecs } from '../../features/media-units/hooks/use-bulk-download-specs';
import { useSupplierPhotoZip } from '../../features/media-units/hooks/use-supplier-photo-zip';
import { useBulkSelectionGate } from '../../features/media-units/hooks/use-bulk-selection-gate';
import { BulkMarkAvailabilityAction } from '../../features/media-units/components/bulk-mark-availability-action';
import { BulkEditAction } from '../../features/media-units/components/bulk-edit-action';
import { BulkRecomputeLocationAction } from '../../features/media-units/components/bulk-recompute-location-action';
import { BulkDeleteAction } from '../../features/media-units/components/bulk-delete-action';
import { SelectAllMatchingBanner } from '../../features/media-units/components/select-all-matching-banner';
import { SupplierPhotoZipTrigger } from '../../features/media-units/components/supplier-photo-zip-trigger';
import { useOfferContext } from '../../features/offers/add-via-catalog/hooks/use-offer-context';
import { useOfferContextNavigation } from '../../features/offers/add-via-catalog/hooks/use-offer-context-navigation';
import { OfferContextBar } from '../../features/offers/add-via-catalog/components/offer-context-bar';
import type { MediaUnitsSearch } from '../../features/media-units/lib/validate-search';

export type { MediaUnitsSearch };

type QuickAddClientSource = Pick<Client, 'id' | 'name' | 'brands' | 'acronym'>;

/** FilterPanel "Dodaj filtr" id for the boolean "bez zdjęcia" (no-photo) sidecar pill. */
const NO_PHOTO_FILTER_ID = 'no-photo';

/** FilterPanel "Dodaj filtr" id for the availability date-range sidecar pill. */
const AVAILABILITY_FILTER_ID = 'availability';

/** FilterPanel id for the import-job catalog filter chip (seeded only by import-result CTA). */
const IMPORT_JOB_FILTER_ID = 'import-job';

export const Route = createFileRoute('/media-units/')({
  validateSearch: validateMediaUnitsSearch,
  component: MediaUnitsPage,
});

export function MediaUnitsPage() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const canQuickAddToOffer = useHasPermission('offer.prepare');
  const canAssignOtherSalesperson = useHasPermission('offer.assign_other_salesperson');
  const canCreateClient = useHasPermission('client.create');
  const canEdit = useHasPermission('media_unit.edit');
  // Gates the "Dodaj nośnik" primary toolbar button — hide-only, per the page-level
  // create-action convention (mirrors Kosz/Importuj z pliku gating below). Server
  // enforces media_unit.create per unit (mediaType + ownership) on POST /media-units;
  // this only decides whether the affordance renders.
  const canCreateMediaUnit = useHasPermission('media_unit.create');
  const canViewCosts = useHasPermission('cost.view');
  const canViewRent = useHasWildcardPermission('cost.view_rent');
  const canViewAvailabilityCalendar = useHasPermission(AVAILABILITY_CALENDAR_CAPABILITY);
  const canDownloadSpecs = useHasPermission('media_unit.view');
  // Gates access to the whole catalog page — a caller without media_unit.view sees the
  // unauthorized fallback below (no availability control, no table) instead of the catalog.
  const canViewInventory = canDownloadSpecs;
  // Gates the bulk "Zablokuj dostępność" catalog-list action (availability-windows-model).
  // Also turns on the pre-existing bulk-edit-media checkbox-selection column so this
  // action can reuse its explicit-id-selection UX verbatim (no parallel selection UI).
  // Also feeds canImportAvailability below (same permission gates the "Zaktualizuj
  // dostępność" entry in the consolidated toolbar Import… dropdown).
  const canBulkMarkAvailability = useHasPermission('media_unit.block_availability');
  // Gates the "Edytuj masowo" bulk-edit-media action. Shares the same checkbox-selection
  // column as canBulkMarkAvailability (see canBulkEdit below) so either permission holder
  // sees the same selection UX.
  const canBulkEditMedia = useHasPermission('bulk_edit');
  // Gates the destructive "Usuń zaznaczone" bulk-delete action in the shared toolbar.
  // Server enforces media_unit.delete per unit (mediaType + ownership); this only
  // decides whether the affordance renders. Also feeds canBulkEditAny below so the
  // shared checkbox-selection column turns on for a delete-only permission holder.
  const canDeleteMedia = useHasPermission('media_unit.delete');
  // Either bulk-action permission holder gets the shared checkbox-selection column;
  // also gates the "select all N matching" banner below the table (see bulkSelectionActive).
  const canBulkEditAny = canBulkMarkAvailability || canBulkEditMedia || canDeleteMedia;
  // Supplier details (name/number/contact) are gated by their own supplier.view
  // capability, independent of cost.view — see the "Inventory table omits
  // restricted columns per role permission" requirement (field-visibility /
  // catalog-column-filter-parity). Previously this copied canViewCosts, which
  // showed supplier columns to cost.view-only roles and hid them from
  // supplier.view-only roles.
  const canViewSupplierDetails = useHasPermission('supplier.view');
  // Whether the caller's own permission scope genuinely narrows what they can
  // see (non-wildcard media_unit.view/supplier.view grant) — feeds the empty
  // state's permission-possible-cause caveat, shared with Mapa (CU-86cbenzvw).
  const hasNarrowedVisibility = useHasNarrowedVisibility();
  const [isPickerOpen, setIsPickerOpen] = React.useState(false);
  const [pickerMediaUnitIds, setPickerMediaUnitIds] = React.useState<number[]>([]);
  const routeSearch = useSearch({ from: '/media-units/' }) as MediaUnitsSearch;
  const { offerContext } = useOfferContext(routeSearch.addToOfferId);
  // Locked-target mode (offerContext present) pins the picker to that offer and
  // synthesizes its own single-entry draft, so the drafts list goes unused.
  const isOfferContextLocked = offerContext != null;
  // The availability-import menu entry shares the same "Import…" trigger as the
  // media-unit importer, so it must honor the same add-to-offer-context hiding
  // rule (CU-86cak2294) — otherwise it would stay visible while the catalog is
  // opened in "add media units to an offer" mode.
  const canImportAvailability = resolveCanImport(canBulkMarkAvailability, routeSearch.addToOfferId);
  const { draftsData, lastUsedData } = useQuickAddPickerData({ enabled: !isOfferContextLocked });
  const clientsQuery = useClientsList();
  const salesUsersQuery = useOfferSalesUsers();
  const { confirm, openFullForm, navigateToNewOffer } = useQuickAddPipeline();
  const page = useMediaUnitsPage({
    canQuickAddToOffer,
    canViewCosts,
    canViewRent,
    canViewSupplierDetails,
    canBulkEdit: canBulkEditAny,
  });
  const { t, tCommon } = page;
  // Supplier-photo ZIP export is offered only when exactly one supplier is in scope.
  const supplierIdFilter = page.filterValue.supplierId;
  const scopedSupplierId = supplierIdFilter?.length === 1 ? Number(supplierIdFilter[0]) : null;
  const { t: tMap } = useTranslation('map');
  const { t: tReservations } = useTranslation('reservations');
  const router = useRouter();
  const navigate = useNavigate({ from: Route.fullPath });
  const { handleReturnToOffer, handleExitOfferContext } = useOfferContextNavigation(
    offerContext,
    navigate,
  );

  // FAIL-CLOSED gate: coordinate detection on the catalog search box renders only
  // when the map-coordinate-search feature flag is enabled. When off, the search
  // box behaves as a plain multi-column text search with no coordinate behavior.
  const isMapCoordinateSearchEnabled = useMapCoordinateSearchEnabled();
  const searchCoordinates = React.useMemo(
    () => (isMapCoordinateSearchEnabled ? parseCoordinates(page.searchValue) : null),
    [isMapCoordinateSearchEnabled, page.searchValue],
  );
  const openSearchCoordinatesOnMap = React.useCallback(() => {
    if (!searchCoordinates) return;
    void router.navigate({
      to: '/map',
      search: {
        lat: searchCoordinates.lat,
        lng: searchCoordinates.lng,
        zoom: COORDINATE_SEARCH_ZOOM,
      },
    });
  }, [router, searchCoordinates]);

  const viewState = useInventoryViewState();
  const { auth } = useRouteContext({ from: '__root__' });

  // ─── Availability calendar: occupancy query ───────────────────
  // Fetch occupancy for the units visible on the current page.
  // Key includes unit ids so TanStack Query refetches when pagination changes.
  const currentUnitIds = React.useMemo(() => page.allRows.map((row) => row.id), [page.allRows]);
  const availabilityWindow = React.useMemo(() => buildAvailabilityWindow(), []);
  // isCalendarActive is the single source of truth for "the availability columns
  // are visible", shared by the periods memo below and the query's `enabled` flag.
  // Duplicating this expression in both places would let them silently diverge
  // (e.g. periods recomputed with no matching fetch, or vice versa).
  const isCalendarActive = viewState.showMonthColumns;
  // Shared "load more periods" window (see proposal.md: manual +3-month steps, 12-month
  // cap). Lives at route level (not per-row) so vertically-loaded rows inherit the same
  // window/column axis as the rows already on screen — see the "Global shared timeline"
  // decision.
  const { monthsAhead, canLoadMore, loadMore } = useAvailabilityLoadMoreWindow();
  // buildPeriods() anchors on `new Date()` at call time, so this must recompute
  // whenever the calendar becomes relevant, not only when granularity changes.
  // Without isCalendarActive as a dep, switching into the calendar view via a
  // client-side search-param change (no remount, e.g. E2E tests avoiding a reload to
  // preserve auth) would keep serving periods anchored to whatever moment the page
  // first mounted — silently stale the longer the table view was open first (e.g.
  // across a real month rollover).
  const availabilityPeriods = React.useMemo(
    () => buildPeriods(viewState.granularity, monthsAhead),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- isCalendarActive is an intentional recompute trigger, not a value read inside the callback
    [viewState.granularity, monthsAhead, isCalendarActive],
  );
  const { data: availabilityData } = useQuery({
    ...mediaUnitAvailabilityQuery(
      auth,
      currentUnitIds,
      availabilityWindow.from,
      availabilityWindow.to,
    ),
    enabled: canViewAvailabilityCalendar && isCalendarActive && currentUnitIds.length > 0,
  });
  const occupancyByRowId = React.useMemo(
    () => (availabilityData ? mapAvailabilityResponseToOccupancy(availabilityData) : {}),
    [availabilityData],
  );

  // ─── Multi-select SELECT/INSPECT flow state (task 4.5, unified-availability-interaction) ──
  // Selection state is lifted to the route rather than reintroducing AvailabilityGrid as this
  // surface's cell-rendering engine (per proposal.md's "Inventory catalog multi-select
  // mechanism" decision — preserves the DataTable column-resize/reorder/virtualization
  // benefits from 2026-07-08-merge-inventory-availability-view).
  const {
    multiSelection,
    anchorRef: multiSelectAnchorRef,
    updateSelection: updateMultiSelectAnchor,
    narrowSelection: narrowMultiSelection,
  } = useMultiSelectAnchor(RICH_AVAILABILITY_CELL_TESTID_PREFIX);
  const [chosenOffer, setChosenOffer] = React.useState<ResolvedOffer | null>(null);
  // Opens the SELECT popover's own "which offer" picker as a real modal (see
  // QuickAddOfferPickerCompactTrigger) instead of embedding a second, cramped copy of
  // QuickAddOfferPicker inline in the popover.
  const [isSelectOfferPickerOpen, setIsSelectOfferPickerOpen] = React.useState(false);
  const queryClient = useQueryClient();
  const canManageReservations = useHasPermission('reservation.manage');
  const reservationPermissions = useReservationPermissions();
  const upgradeHard = useUpgradeHard();
  const closeSale = useCloseSale();
  const cancelReservation = useCancelReservation();
  const forceRelease = useForceRelease();
  // Real per-cell CellEntry[] data (holder/client/offer/TTL/reservationId/queue) for the
  // INSPECT popover and own-reservation resolution — reuses the SAME availability response
  // this route already fetches for occupancyByRowId, via the existing (previously unused
  // by this route) mapAvailabilityResponseToEntriesGrid mapper. Period IDs are derived from
  // the YYYY-MM prefix — correct at 'month' granularity; day/week/half-month granularities
  // lose this signal (same pre-existing limitation as the detail card's identical wiring,
  // routes/media-units/$id/index.tsx:detailEntriesGrid).
  const inventoryEntriesGrid = React.useMemo(
    () => (availabilityData ? mapAvailabilityResponseToEntriesGrid(availabilityData) : {}),
    [availabilityData],
  );
  // Plain (unitId, periodId) grid mirroring buildRichAvailabilityColumns's own internal
  // grid — recomputed here (cheap, same inputs) so the route's own rectangle-selection
  // math (computeMultiSelectRectangle) can classify cell eligibility without threading the
  // column builder's private grid back out.
  const inventoryGrid = React.useMemo(
    () =>
      buildInventoryAvailabilityGrid(
        currentUnitIds.map(String),
        availabilityPeriods,
        occupancyByRowId,
      ),
    [currentUnitIds, availabilityPeriods, occupancyByRowId],
  );
  const inventoryGridRows = React.useMemo(
    () => currentUnitIds.map((id) => ({ id: String(id), label: '' })),
    [currentUnitIds],
  );
  const inventoryDragStartRef = React.useRef<MultiSelectCellRef | null>(null);
  const inventoryIsDraggingRef = React.useRef(false);

  const clearMultiSelection = React.useCallback(() => {
    updateMultiSelectAnchor(null);
    setChosenOffer(null);
  }, [updateMultiSelectAnchor]);

  const { handleCalendarPickerConfirm } = useCalendarOfferPicker({
    closeCalendarPicker: () => setIsSelectOfferPickerOpen(false),
    setCalendarResolvedOffer: setChosenOffer,
  });

  const resolveInventoryMultiSelectCell = React.useCallback(
    (ref: MultiSelectCellRef): UnifiedSelectCellResolution | null =>
      resolveAvailabilityMultiSelectCell(ref, availabilityPeriods, inventoryEntriesGrid),
    [availabilityPeriods, inventoryEntriesGrid],
  );

  // Defaults the calendar-driven "creating"-mode offer picker's campaign-duration
  // field to the exact month/period the caller just selected (CU-86cb8grgr).
  const calendarPickerDefaultRange = React.useMemo(
    () => resolveFreeCellDateRange(multiSelection, resolveInventoryMultiSelectCell),
    [multiSelection, resolveInventoryMultiSelectCell],
  );

  // Media unit(s) referenced by the current calendar selection — carried through
  // "Otwórz pełny formularz" instead of being lost (CU-86cb8grgn).
  const calendarPickerMediaUnitIds = React.useMemo(
    () => resolveSelectedMediaUnitIds(multiSelection),
    [multiSelection],
  );

  const refreshAvailability = React.useCallback(
    () => void queryClient.invalidateQueries({ queryKey: MEDIA_UNIT_AVAILABILITY_KEY_PREFIX }),
    [queryClient],
  );
  const {
    handleBatchReserveSuccess: handleInventoryBatchReserveSuccess,
    handleBatchReleaseSuccess: handleInventoryBatchReleaseSuccess,
  } = useSelectBatchResults({
    periods: availabilityPeriods,
    narrowSelection: narrowMultiSelection,
    resolveCell: resolveInventoryMultiSelectCell,
    refreshAvailability,
  });

  // Click / drag / shift-click rectangle-selection mechanics — mirrors AvailabilityGrid's
  // own internal multiSelect handlers (availability-grid.tsx:handleMultiCell*), reusing the
  // exact same computeMultiSelectRectangle geometry algorithm since this surface has no
  // AvailabilityGrid instance to own this state internally.
  const handleInventoryCellClick = React.useCallback(
    (rowId: string, period: InventoryAvailabilityPeriod, shiftKey: boolean) => {
      if (shiftKey && multiSelection?.anchor) {
        const cells = computeMultiSelectRectangle(
          inventoryGridRows,
          availabilityPeriods,
          inventoryGrid,
          multiSelection.anchor,
          { unitId: rowId, periodId: period.id },
        );
        updateMultiSelectAnchor({ cells, anchor: { unitId: rowId, periodId: period.id } });
        return;
      }
      const cellState = inventoryGrid[rowId]?.[period.id] ?? 'free';
      if (!isShiftSelectableState(cellState)) return;
      updateMultiSelectAnchor({
        cells: [{ unitId: rowId, periodId: period.id }],
        anchor: { unitId: rowId, periodId: period.id },
      });
    },
    [
      multiSelection,
      inventoryGridRows,
      availabilityPeriods,
      inventoryGrid,
      updateMultiSelectAnchor,
    ],
  );

  const handleInventoryCellMouseDown = React.useCallback(
    (rowId: string, period: InventoryAvailabilityPeriod) => {
      inventoryDragStartRef.current = { unitId: rowId, periodId: period.id };
      inventoryIsDraggingRef.current = false;
    },
    [],
  );

  const handleInventoryCellMouseEnter = React.useCallback(
    (rowId: string, period: InventoryAvailabilityPeriod) => {
      const start = inventoryDragStartRef.current;
      if (!start || (start.unitId === rowId && start.periodId === period.id)) return;
      inventoryIsDraggingRef.current = true;
      const cells = computeMultiSelectRectangle(
        inventoryGridRows,
        availabilityPeriods,
        inventoryGrid,
        start,
        { unitId: rowId, periodId: period.id },
      );
      updateMultiSelectAnchor({ cells, anchor: { unitId: rowId, periodId: period.id } });
    },
    [inventoryGridRows, availabilityPeriods, inventoryGrid, updateMultiSelectAnchor],
  );

  const handleInventoryCellMouseUp = React.useCallback(
    (rowId: string, period: InventoryAvailabilityPeriod) => {
      const start = inventoryDragStartRef.current;
      if (inventoryIsDraggingRef.current && start) {
        const cells = computeMultiSelectRectangle(
          inventoryGridRows,
          availabilityPeriods,
          inventoryGrid,
          start,
          { unitId: rowId, periodId: period.id },
        );
        updateMultiSelectAnchor({ cells, anchor: { unitId: rowId, periodId: period.id } });
      }
      inventoryDragStartRef.current = null;
      inventoryIsDraggingRef.current = false;
    },
    [inventoryGridRows, availabilityPeriods, inventoryGrid, updateMultiSelectAnchor],
  );

  // Single shared bulk-selection state for the whole catalog list — quick-add-to-offer,
  // bulk-edit-media, and availability-windows bulk mark-availability all read/write it.
  const {
    bulkSelectedIds,
    bulkSelectedCount,
    bulkSelectAllFilter,
    bulkClearSelection,
    bulkActivateSelectAllFilter,
  } = page;
  const isBulkSelectAllFilterActive = bulkSelectAllFilter != null;
  const bulkSelectedIdsArray = React.useMemo(() => Array.from(bulkSelectedIds), [bulkSelectedIds]);
  // Photo ZIP export resolves units by grwId (SupplierPhotoManifestRequest's `grwIds`
  // selector), unlike the spec bulk-download trigger which uses numeric unit ids directly.
  // Resolved from page.seenRowsById (every row loaded this session, not just the
  // current page) so a unit hidden by a later search still resolves — no server
  // round-trip needed since the user could only have checked a row they'd already
  // seen (row-selection spec: bulk actions cover hidden selected units).
  const selectedGrwIds = React.useMemo(
    () =>
      bulkSelectedIdsArray
        .map((id) => page.seenRowsById.get(id)?.grwId)
        .filter((grwId): grwId is string => grwId != null),
    [bulkSelectedIdsArray, page.seenRowsById],
  );
  // How many of the checkbox selection are not among the currently loaded rows —
  // fed into each bulk-action confirmation's hidden-count line (row-selection
  // spec: confirmations state items outside the current results).
  const bulkShownIdSet = React.useMemo(
    () => new Set(page.allRows.map((row) => row.id)),
    [page.allRows],
  );
  const bulkHiddenCount = React.useMemo(
    () => bulkSelectedIdsArray.filter((id) => !bulkShownIdSet.has(id)).length,
    [bulkSelectedIdsArray, bulkShownIdSet],
  );
  // I/O boundary: buildQuickAddPickerLabels passes string keys from a fixed external namespace;
  // the typed TFunction only accepts enumerated keys, so a narrow cast is required here.
  const translatePickerLabel = React.useCallback(
    (key: string): string => (t as (k: string) => string)(key),
    [t],
  );
  const drafts = draftsData?.drafts ?? [];
  const initialSelectedDraftId = getInitialSelectedDraftId(draftsData, lastUsedData);
  const [selectedDraftId, setSelectedDraftId] = React.useState<string | null>(
    initialSelectedDraftId,
  );
  // Auto-applies the preselected draft to the SELECT popover's Rezerwacja/Opcja actions
  // with no extra confirm click — only overridden once the user actively picks a
  // different offer via the modal (which sets `chosenOffer` explicitly).
  const preselectedOfferId = React.useMemo(
    () => resolvePreselectedOfferId(drafts, selectedDraftId),
    [drafts, selectedDraftId],
  );
  const pickerLabels = React.useMemo(
    () => buildQuickAddPickerLabels(translatePickerLabel, INVENTORY_QUICK_ADD_PICKER_BASE_KEY),
    [translatePickerLabel],
  );
  const availableClients = React.useMemo<QuickAddClientSource[]>(() => {
    return normalizeClientList(clientsQuery.data);
  }, [clientsQuery.data]);
  const clientOptions = React.useMemo(
    () =>
      availableClients.map((client) => ({
        label: client.name,
        value: String(client.id),
        brands: client.brands,
        acronym: client.acronym,
      })),
    [availableClients],
  );
  const salesUsers = React.useMemo(() => salesUsersQuery.data ?? [], [salesUsersQuery.data]);
  // QuickAddOfferPicker never calls useCampaignNumberPreview itself (no
  // router/query context in apps/mockups) — it reports the "creating" mode
  // form's current selection here via onCampaignNumberPreviewInputChange,
  // and this page feeds it into the real hook and passes the result back via
  // campaignNumberPreview (offer-draft-numbering / "Campaign-number preview
  // on offer creation forms"). Shared across both QuickAddOfferPicker
  // instances below since only one is ever open at a time.
  const [campaignNumberPreviewInput, setCampaignNumberPreviewInput] =
    React.useState<CampaignNumberPreviewQuery | null>(null);
  const campaignNumberPreview = useCampaignNumberPreview(campaignNumberPreviewInput);

  React.useEffect(() => {
    setSelectedDraftId(initialSelectedDraftId);
  }, [initialSelectedDraftId]);

  const nearPoiFilterLabel = tMap('pois.filterSection.label');
  const noPhotoFilterLabel = t('filters.noPhoto');
  const availabilityFilterLabel = t('filters.availability');
  const importJobChipLabel =
    page.importJobId != null ? t('filters.importJobChip', { id: page.importJobId }) : '';
  const extraHiddenItems = React.useMemo(
    () => [
      { id: NEAR_POI_FILTER_ID, label: nearPoiFilterLabel },
      { id: NO_PHOTO_FILTER_ID, label: noPhotoFilterLabel },
      { id: AVAILABILITY_FILTER_ID, label: availabilityFilterLabel },
      { id: IMPORT_JOB_FILTER_ID, label: importJobChipLabel },
    ],
    [nearPoiFilterLabel, noPhotoFilterLabel, availabilityFilterLabel, importJobChipLabel],
  );

  // Seed pills as visible if their params are already in the URL (e.g. from shared link / back nav).
  // Empty dep array is intentional — value must only be computed once at mount.

  const defaultVisibleExtraIds = React.useMemo(
    () => {
      const ids: string[] = [];
      if (isPoiFilterActive(page.poiFilterParams)) ids.push(NEAR_POI_FILTER_ID);
      if (page.noPhoto) ids.push(NO_PHOTO_FILTER_ID);
      if (page.availabilityRange.length > 0) ids.push(AVAILABILITY_FILTER_ID);
      if (page.importJobId != null) ids.push(IMPORT_JOB_FILTER_ID);
      return ids;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const renderExtraPill = React.useCallback(
    (id: string, onHide: () => void) => {
      if (id === NEAR_POI_FILTER_ID) {
        return (
          <NearPoiFilterSection
            value={page.poiFilterParams}
            onChange={page.setPoiFilterParams}
            onHide={() => {
              page.setPoiFilterParams({});
              onHide();
            }}
            nearPoiName={page.nearPoiName}
          />
        );
      }
      if (id === NO_PHOTO_FILTER_ID) {
        return (
          <BooleanFilterPill
            label={noPhotoFilterLabel}
            onClear={() => {
              page.setNoPhoto(false);
              onHide();
            }}
            clearAriaLabel={t('filters.clearLabel')}
            testId="filter-no-photo"
          />
        );
      }
      if (id === AVAILABILITY_FILTER_ID) {
        return (
          <DateRangePill
            field={{
              type: 'dateRange',
              id: AVAILABILITY_FILTER_ID,
              label: availabilityFilterLabel,
            }}
            selected={page.availabilityRange}
            onChange={(_id, values) => page.setAvailabilityRange(values)}
            onClear={() => {
              page.setAvailabilityRange([]);
              onHide();
            }}
            labels={page.filterPanelLabels}
          />
        );
      }
      if (id === IMPORT_JOB_FILTER_ID) {
        return (
          <BooleanFilterPill
            label={importJobChipLabel}
            onClear={() => {
              page.setImportJobId(undefined);
              onHide();
            }}
            clearAriaLabel={t('filters.clearLabel')}
            testId="filter-import-job"
          />
        );
      }
      return null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- destructured page props are the correct deps
    [
      page.poiFilterParams,
      page.setPoiFilterParams,
      page.nearPoiName,
      page.setNoPhoto,
      page.availabilityRange,
      page.setAvailabilityRange,
      page.filterPanelLabels,
      page.importJobId,
      page.setImportJobId,
      noPhotoFilterLabel,
      availabilityFilterLabel,
      importJobChipLabel,
      t,
    ],
  );

  // Boolean filters apply on add (Polaris appliedFilters model): selecting "bez zdjęcia"
  // from the menu immediately sets the value, so there is no "added but not applied" pill.
  const handleShowExtra = React.useCallback(
    (id: string) => {
      if (id === NO_PHOTO_FILTER_ID) page.setNoPhoto(true);
    },
    [page.setNoPhoto],
  );

  // Exclude-mode extension point: only excludable dimensions present in the field list.
  const excludableFieldIds = React.useMemo<string[]>(() => [...EXCLUDABLE_FILTER_FIELDS], []);
  const excludeLabels = React.useMemo(
    () => ({
      includeLabel: t('filters.exclude.include'),
      excludeLabel: t('filters.exclude.exclude'),
      getToggleAriaLabel: (fieldId: string) => t('filters.exclude.toggleAria', { field: fieldId }),
    }),
    [t],
  );
  const handleToggleExclude = React.useCallback(
    (fieldId: string) => {
      if ((EXCLUDABLE_FILTER_FIELDS as readonly string[]).includes(fieldId)) {
        page.toggleExcludedField(fieldId as ExcludableFilterField);
      }
    },
    [page],
  );

  React.useEffect(() => {
    setPageTitle(t('pageTitle'));
  }, [setPageTitle, t]);

  const colWidth = GRANULARITY_COL_WIDTH[viewState.granularity];

  // ASK_AVAILABILITY cell popover (availability-calendar / "Inventory Page
  // Availability View" requirement — restores the old full-availability grid's
  // distinct "Zapytaj o dostępność" popover for the merged rich cell).
  // "Set status manually" is suppressed here (canManage={false} below) —
  // it was never wired to a backing API endpoint. Matches the suppression
  // already applied on the other two InspectPopover ASK_AVAILABILITY surfaces
  // (routes/media-units/$id/index.tsx, offers/availability-shared). CU-86cap3yuf.
  const enquireAvailabilityLabel = t('availability.enquireAvailability');
  // rowId -> {label, city} lookup for the mailto "enquire" link's subject line.
  const unitLabelByRowId = React.useMemo<Record<string, { label: string; city?: string }>>(
    () =>
      Object.fromEntries(
        page.allRows.map((row) => [
          String(row.id),
          { label: row.supplierNumber ?? row.grwId, city: row.city },
        ]),
      ),
    [page.allRows],
  );
  const buildEnquireHref = React.useCallback(
    (rowId: string): string => {
      const unit = unitLabelByRowId[rowId];
      return buildAvailabilityEnquiryHref(unit?.label ?? '', unit?.city, t);
    },
    [unitLabelByRowId, t],
  );
  // Controls RichAvailabilityCell's own (small) click popover for INSPECT-eligible
  // (occupied) cells only — SELECT-eligible cells never open this (see `selectable` in
  // buildRichAvailabilityColumns), routing through the shared multiSelection state instead.
  const [richOpenCellKey, setRichOpenCellKey] = React.useState<string | null>(null);

  // ─── Universal queue popup (CU-86cb7ewja) ──────────────────────────────────
  // No offer is in scope on this catalog surface, so a join here always resolves
  // client+brand identity fields (standalone) rather than the offer-tab's editable
  // offer identity — see resolveQueueJoinIdentity in build-queue-join-section.tsx.
  const richOpenCellQueueContext = React.useMemo(() => {
    if (!richOpenCellKey) {
      return {
        mediaUnitId: 0,
        dateFrom: '',
        dateTo: '',
        enabled: false as const,
        ownership: 'other' as const,
      };
    }
    const separatorIndex = richOpenCellKey.indexOf(':');
    const rowId = richOpenCellKey.slice(0, separatorIndex);
    const periodId = richOpenCellKey.slice(separatorIndex + 1);
    const entries = inventoryEntriesGrid[rowId]?.[periodId] ?? [];
    const period = availabilityPeriods.find((p) => p.id === periodId);
    return resolveCellQueueWindowContext(entries, period, Number(rowId));
  }, [richOpenCellKey, inventoryEntriesGrid, availabilityPeriods]);

  const {
    activeQueueState: richOpenCellQueueState,
    queueInfo: richOpenCellQueueInfo,
    currentUserId: catalogCurrentUserId,
    handleJoin: handleCatalogJoinQueue,
    handleQueueAction: handleCatalogQueueAction,
    isJoinPending: isCatalogJoinPending,
  } = useCellQueueJoin(richOpenCellQueueContext);
  const catalogQueueClientOptions = useQueueClientOptions();
  const catalogQueueOfferOptions = useQueueOfferOptions();
  const catalogQueueJoinPanelLabels = React.useMemo(
    () =>
      buildQueueJoinPanelLabels(
        tReservations as (key: string, options?: Record<string, unknown>) => string,
      ),
    [tReservations],
  );

  const {
    queueJoinSection: catalogSelectQueueJoinSection,
    queueJoinLoading: isCatalogSelectQueueLoading,
  } = useSelectQueueJoin({
    selection: multiSelection,
    resolveCell: resolveInventoryMultiSelectCell,
    testId: 'catalog-select-queue',
    clientOptions: catalogQueueClientOptions,
    offerOptions: catalogQueueOfferOptions,
    labels: catalogQueueJoinPanelLabels,
  });

  // Rich availability columns appended to the inventory DataTable when the
  // "Dostępność" toggle is on — reuses the shared cell helpers via
  // RichAvailabilityCell (buildRichAvailabilityColumns) so cells look and behave
  // like the removed full-availability grid, not a stripped-down preview.
  //
  // renderPopoverContent is now only ever invoked for INSPECT-eligible (occupied) cells —
  // buildRichAvailabilityColumns routes SELECT-eligible cells (free/option-own/reserved-own)
  // to select mode via onCellClick/isCellSelected/mouse handlers instead, replacing the
  // retired per-cell Rezerwacja/Opcja/Zablokuj inline-actions shim with the shared
  // UnifiedSelectPopover rendered below (unify-availability-interaction task 4.5).
  const richAvailabilityColumns = React.useMemo(
    () =>
      viewState.showMonthColumns
        ? buildRichAvailabilityColumns<MediaUnitListItem>({
            periods: availabilityPeriods,
            rowIds: currentUnitIds,
            occupancyByRowId,
            colWidth,
            granularity: viewState.granularity,
            expiresLabelPrefix: t('availability.inspect.expiresLabel'),
            openCellKey: richOpenCellKey,
            onOpenCellKeyChange: setRichOpenCellKey,
            onCellClick: canManageReservations ? handleInventoryCellClick : undefined,
            onCellMouseDown: canManageReservations ? handleInventoryCellMouseDown : undefined,
            onCellMouseEnter: canManageReservations ? handleInventoryCellMouseEnter : undefined,
            onCellMouseUp: canManageReservations ? handleInventoryCellMouseUp : undefined,
            isCellSelected: (rowId, periodId) =>
              multiSelection?.cells.some((c) => c.unitId === rowId && c.periodId === periodId) ??
              false,
            renderPopoverContent: ({
              rowId,
              period,
              state,
            }: {
              rowId: string;
              period: InventoryAvailabilityPeriod;
              state: CellState;
            }) => {
              if (state === 'unknown') {
                return (
                  <InspectPopover
                    entries={[]}
                    cellState={state}
                    unitLabel={unitLabelByRowId[rowId]?.label ?? rowId}
                    dateRangeLabel={period.label}
                    mediaUnitId={Number(rowId)}
                    hasLabelAuthorization={false}
                    canUpgradeHard={false}
                    canCloseSale={false}
                    canCancel={false}
                    canForceRelease={false}
                    canManage={false}
                    enquireLabel={enquireAvailabilityLabel}
                    enquireHref={buildEnquireHref(rowId)}
                    setStatusManuallyLabel=""
                    testId={`rich-availability-popover-content-${rowId}-${period.id}`}
                  />
                );
              }
              const entries = inventoryEntriesGrid[rowId]?.[period.id] ?? [];
              const { dominant } = resolveDominantEntry(entries);
              const cellTestId = `rich-availability-popover-content-${rowId}-${period.id}`;
              const isRichCellOpen = richOpenCellKey === `${rowId}:${period.id}`;
              const richQueueInfo = isRichCellOpen ? richOpenCellQueueInfo : undefined;
              const richQueueSection = buildQueueJoinSection(isRichCellOpen, cellTestId, {
                activeQueueState: richOpenCellQueueState,
                currentUserId: catalogCurrentUserId,
                queueListId: Number(rowId),
                clientOptions: catalogQueueClientOptions,
                offerOptions: catalogQueueOfferOptions,
                labels: catalogQueueJoinPanelLabels,
                onJoin: handleCatalogJoinQueue,
                onQueueAction: handleCatalogQueueAction,
                isJoinPending: isCatalogJoinPending,
              });
              return (
                <InspectPopover
                  entries={entries}
                  cellState={state}
                  unitLabel={unitLabelByRowId[rowId]?.label ?? rowId}
                  dateRangeLabel={period.label}
                  mediaUnitId={Number(rowId)}
                  inspectedCellDateFrom={period.start}
                  inspectedCellDateTo={period.end}
                  // hasLabelAuthorization relies on the backend's own field-level
                  // redaction (rezerwujący/klient/oferta are absent from CellEntry when
                  // unauthorized) — same pattern as routes/media-units/$id/index.tsx
                  // (task 4.4, findings.md "hasLabelAuthorization passed as
                  // unconditional true").
                  hasLabelAuthorization={true}
                  canUpgradeHard={reservationPermissions.canUpgradeHard}
                  canCloseSale={reservationPermissions.canCloseSale}
                  canCancel={reservationPermissions.canCancel}
                  canForceRelease={reservationPermissions.canForceRelease}
                  onExpired={() =>
                    void queryClient.invalidateQueries({
                      queryKey: MEDIA_UNIT_AVAILABILITY_KEY_PREFIX,
                    })
                  }
                  {...buildInspectQuickActionHandlers(dominant, Number(rowId), {
                    upgradeHard,
                    closeSale,
                    cancelReservation,
                    forceRelease,
                  })}
                  queueInfo={richQueueInfo}
                  queueSection={richQueueSection}
                  canManage={false}
                  enquireLabel={enquireAvailabilityLabel}
                  enquireHref={buildEnquireHref(rowId)}
                  setStatusManuallyLabel=""
                  testId={cellTestId}
                />
              );
            },
          })
        : [],
    [
      viewState.showMonthColumns,
      viewState.granularity,
      availabilityPeriods,
      currentUnitIds,
      occupancyByRowId,
      colWidth,
      richOpenCellKey,
      unitLabelByRowId,
      enquireAvailabilityLabel,
      buildEnquireHref,
      canManageReservations,
      handleInventoryCellClick,
      handleInventoryCellMouseDown,
      handleInventoryCellMouseEnter,
      handleInventoryCellMouseUp,
      multiSelection,
      inventoryEntriesGrid,
      reservationPermissions,
      upgradeHard,
      closeSale,
      cancelReservation,
      forceRelease,
      queryClient,
      richOpenCellQueueState,
      richOpenCellQueueInfo,
      catalogCurrentUserId,
      catalogQueueClientOptions,
      catalogQueueOfferOptions,
      catalogQueueJoinPanelLabels,
      handleCatalogJoinQueue,
      handleCatalogQueueAction,
      isCatalogJoinPending,
      t,
    ],
  );
  const loadMoreLabel = t('availability.loadMore');
  // Trailing "load more periods" column — only while the availability columns are on
  // AND the shared window hasn't reached the 12-month cap yet. The window is already
  // fully fetched up to 12 months by mediaUnitAvailabilityQuery above, so extending it
  // is an instant re-slice of already-loaded periods (no loading state needed).
  const loadMoreColumns = React.useMemo(
    () =>
      viewState.showMonthColumns && canLoadMore
        ? buildLoadMoreColumn<MediaUnitListItem>(loadMoreLabel, false, loadMore)
        : [],
    [viewState.showMonthColumns, canLoadMore, loadMoreLabel, loadMore],
  );
  const tableColumns = React.useMemo(
    () => [...page.visibleColumns, ...richAvailabilityColumns, ...loadMoreColumns],
    [page.visibleColumns, richAvailabilityColumns, loadMoreColumns],
  );
  // Status legend for the availability sub-toolbar — mirrors the single-unit detail
  // card's legend (media-unit-detail.tsx) for a consistent status vocabulary across
  // every surface that renders the shared availability cell helpers.
  const availabilityLegendItems = React.useMemo(
    () => buildAvailabilityLegendItems(tCommon),
    [tCommon],
  );

  // Multi-sort badges only appear once a secondary sort column is active (shift-click);
  // otherwise DataTable falls back to its single-sort chevron via sortBy/sortDir/onSort.
  const sortOrders = React.useMemo(
    () =>
      page.sortBy2 != null
        ? [
            { key: page.sortBy, order: 1, dir: page.sortDir },
            { key: page.sortBy2, order: 2, dir: page.sortDir2 },
          ]
        : undefined,
    [page.sortBy, page.sortDir, page.sortBy2, page.sortDir2],
  );

  const openQuickAddPicker = React.useCallback((mediaUnitIds: number[]) => {
    setPickerMediaUnitIds(mediaUnitIds);
    setIsPickerOpen(true);
  }, []);

  // Header "Dodaj do oferty" icon always targets every currently loaded/filtered
  // row — the dedicated "add SELECTED units" affordance lives exclusively in the
  // shared BulkActionToolbar below, so there is only one place that claims to
  // "add the checked rows" instead of two competing controls.
  const openHeaderQuickAdd = React.useCallback(() => {
    openQuickAddPicker(page.allRows.map((row) => row.id));
  }, [openQuickAddPicker, page.allRows]);

  // "Mapa" toolbar icon button — navigates to the standalone map view,
  // carrying the shared filter dimensions and addToOfferId (offer context)
  // via buildMapNavigationSearch — see its doc comment for the CU-86cb1nq7h
  // regression this fixes (catalog-column-filter-parity: "Filters survive
  // catalog→map navigation inside offer context").
  const openMap = React.useCallback(() => {
    void navigate({
      to: '/map',
      // `routeSearch` is `MediaUnitsSearch`, a nominal interface with no index
      // signature — the `unknown` intermediate is required so it can widen to
      // the generic `Record<string, unknown>` shape `buildMapNavigationSearch`
      // (a route-agnostic pure helper) accepts. Values themselves are untouched.
      search: buildMapNavigationSearch(routeSearch as unknown as Record<string, unknown>),
    });
  }, [navigate, routeSearch]);

  // "Dodaj nośnik" toolbar button — plain onClick navigation (not a Link/asChild
  // anchor) so it keeps role=button, matching the pre-existing @smoke coverage in
  // apps/web/e2e/media-unit-add.spec.ts (`getByRole('button', { name: 'Dodaj nośnik' })`).
  // Forwards addToOfferId so the "adding to offer X" context survives creating a new
  // unit and returning to the catalog — without this, the picker's "Dodaj zaznaczone
  // do oferty" landed with no offer context after a round trip through this button
  // (CU-86caypxaw).
  const openAddForm = React.useCallback(() => {
    void navigate({
      to: '/media-units/add',
      search: routeSearch.addToOfferId ? { addToOfferId: routeSearch.addToOfferId } : undefined,
    });
  }, [navigate, routeSearch.addToOfferId]);

  // Bulk-edit and bulk-mark-availability drawers/dialogs are controlled from here;
  // their triggers live inside the shared BulkActionToolbar's actions below. Both
  // components stay permanently mounted (only their rendered output is null while
  // closed), so an effect-based internal reset would flash stale data from a prior
  // session for one paint. The `key` below forces a fresh mount on every open,
  // guaranteeing clean state with no flash.
  const [isBulkEditDrawerOpen, setIsBulkEditDrawerOpen] = React.useState(false);
  const [bulkEditOpenKey, setBulkEditOpenKey] = React.useState(0);
  const [isBulkMarkAvailabilityOpen, setIsBulkMarkAvailabilityOpen] = React.useState(false);
  const [bulkMarkAvailabilityOpenKey, setBulkMarkAvailabilityOpenKey] = React.useState(0);
  const {
    start: startBulkDownload,
    pendingManifest: bulkDownloadManifest,
    confirmDownload: confirmBulkDownload,
    cancelDownload: cancelBulkDownload,
  } = useBulkDownloadSpecs();
  const { start: startPhotoZip, isStreaming: isPhotoZipStreaming } = useSupplierPhotoZip();
  // Hoisted out of the useMemo below: useBulkSelectionGate is a plain function (no
  // internal hook calls), but its `use` prefix trips react-hooks/rules-of-hooks if
  // called from inside a callback — call it at the component's top level instead.
  const specDownloadGate = useBulkSelectionGate(
    isBulkSelectAllFilterActive ? 0 : bulkSelectedIdsArray.length,
    BULK_DOWNLOAD_MAX_UNITS,
  );
  const photoDownloadGate = useBulkSelectionGate(
    isBulkSelectAllFilterActive ? 0 : selectedGrwIds.length,
    SUPPLIER_PHOTO_ZIP_MAX_UNITS,
  );
  const [isBulkRecomputeLocationOpen, setIsBulkRecomputeLocationOpen] = React.useState(false);
  const [bulkRecomputeLocationOpenKey, setBulkRecomputeLocationOpenKey] = React.useState(0);
  const [isBulkDeleteOpen, setIsBulkDeleteOpen] = React.useState(false);
  const [bulkDeleteOpenKey, setBulkDeleteOpenKey] = React.useState(0);

  const bulkActions = React.useMemo<BulkAction[]>(() => {
    const actions: BulkAction[] = [];
    if (canQuickAddToOffer) {
      actions.push({
        id: 'add-selected-to-offer',
        label: t('quickAdd.bulkActionLabel'),
        onClick: () => openQuickAddPicker(bulkSelectedIdsArray),
        // Quick-add operates on explicit IDs only — "select all N matching" filter
        // mode (no enumerated IDs on the client) cannot feed it.
        disabled: bulkSelectedIdsArray.length === 0 || isBulkSelectAllFilterActive,
      });
    }
    if (canBulkEditMedia) {
      actions.push({
        id: 'bulk-edit',
        label: t('bulkEdit.action'),
        onClick: () => {
          setBulkEditOpenKey((key) => key + 1);
          setIsBulkEditDrawerOpen(true);
        },
      });
    }
    if (canBulkMarkAvailability) {
      actions.push({
        id: 'bulk-mark-availability',
        label: t('bulkMarkAvailability.action'),
        onClick: () => {
          setBulkMarkAvailabilityOpenKey((key) => key + 1);
          setIsBulkMarkAvailabilityOpen(true);
        },
      });
    }
    if (canDownloadSpecs) {
      // Same explicit-IDs-only constraint as quick-add (the manifest endpoint
      // needs enumerated unit IDs — "select all N matching" filter mode has none
      // on the client), plus the manifest's own unit cap.
      actions.push({
        id: 'bulk-download-specs',
        label: t('bulkDownload.trigger.label'),
        onClick: () => void startBulkDownload(bulkSelectedIdsArray),
        disabled: specDownloadGate.isDisabled,
        disabledTooltip:
          specDownloadGate.tooltipKey === 'cap'
            ? t('bulkDownload.trigger.disabledCap')
            : specDownloadGate.tooltipKey === 'empty'
              ? t('bulkDownload.trigger.disabledEmpty')
              : undefined,
      });

      // Photo ZIP resolves units by grwId, not numeric id — same explicit-selection
      // constraint (no "select all N matching" support) and its own unit cap.
      actions.push({
        id: 'bulk-download-photos',
        label: t('supplierPhotoZip.bulkTrigger.label'),
        onClick: () => void startPhotoZip({ grwIds: selectedGrwIds }),
        disabled: photoDownloadGate.isDisabled || isPhotoZipStreaming,
        disabledTooltip:
          photoDownloadGate.tooltipKey === 'cap'
            ? t('supplierPhotoZip.bulkTrigger.disabledCap')
            : photoDownloadGate.tooltipKey === 'empty'
              ? t('supplierPhotoZip.bulkTrigger.disabledEmpty')
              : undefined,
      });
    }
    if (canBulkEditMedia) {
      actions.push({
        id: 'bulk-recompute-location',
        label: t('bulkRecomputeLocation.action'),
        onClick: () => {
          setBulkRecomputeLocationOpenKey((key) => key + 1);
          setIsBulkRecomputeLocationOpen(true);
        },
      });
    }
    // Destructive "Usuń zaznaczone" — kept last so it never sits adjacent to the
    // non-destructive primary actions. Server enforces media_unit.delete per unit.
    if (canDeleteMedia) {
      actions.push({
        id: 'bulk-delete',
        label: t('bulkDelete.action'),
        variant: 'destructive',
        onClick: () => {
          setBulkDeleteOpenKey((key) => key + 1);
          setIsBulkDeleteOpen(true);
        },
      });
    }
    return actions;
  }, [
    bulkSelectedIdsArray,
    canBulkEditMedia,
    canBulkMarkAvailability,
    canDeleteMedia,
    canDownloadSpecs,
    canQuickAddToOffer,
    isBulkSelectAllFilterActive,
    isPhotoZipStreaming,
    openQuickAddPicker,
    photoDownloadGate,
    selectedGrwIds,
    specDownloadGate,
    startBulkDownload,
    startPhotoZip,
    t,
  ]);

  // The toolbar shows the full matching count once filter-based "select all N
  // matching" selection is active, otherwise the number of explicitly checked rows.
  const bulkToolbarSelectedCount = isBulkSelectAllFilterActive
    ? page.totalCount
    : bulkSelectedCount;
  const showBulkToolbar = bulkActions.length > 0 && bulkToolbarSelectedCount > 0;

  const pickerCount = pickerMediaUnitIds.length;
  const headerQuickAddLabel = t('quickAdd.addAllFiltered');

  const offerContextBarNode =
    offerContext !== null ? (
      <div className="sticky top-0 z-20 mb-4">
        <OfferContextBar
          message={t('offerContext.bar.message', { offerName: offerContext.offerName })}
          returnLabel={t('offerContext.bar.returnLabel')}
          exitAriaLabel={t('offerContext.bar.exitAriaLabel')}
          onReturnToOffer={handleReturnToOffer}
          onExit={handleExitOfferContext}
        />
      </div>
    ) : null;

  // Single source of truth for the search/filter row + dense action row so the
  // empty-state branch below renders the exact same toolbar as the populated
  // page — "same page, just without the table" — instead of a bespoke,
  // drifted-looking subset (see media-units empty-state alignment fix).
  const filterAndToolbarBlock = (
    <>
      <div className="mb-4 shrink-0">
        {/* Search lives inline in FilterPanel's leadingContent below, so search and
            filter pills share ONE flex-wrap container instead of two independently
            wrapping rows. The dense action row (mirrors
            apps/mockups/src/screens/media-inventory.mockup.tsx's "table-action-row")
            sits directly below this row, above the table. */}
        <FilterPanel
          leadingContent={
            <PillWrapper label="&nbsp;" showLabel={false}>
              <div className="flex items-center gap-2">
                <InventorySearchInput
                  value={page.searchValue}
                  onChange={page.setSearchValue}
                  placeholder={t('filters.searchBox.placeholder')}
                  ariaLabel={t('filters.searchBox.ariaLabel')}
                  expandOnFocus
                />
                {searchCoordinates ? (
                  <CatalogOpenOnMapAction
                    label={t('filters.searchBox.openOnMap')}
                    onOpen={openSearchCoordinatesOnMap}
                  />
                ) : null}
              </div>
            </PillWrapper>
          }
          fields={page.filterFields}
          value={page.filterValue}
          onChange={page.handleFiltersChange}
          onClearAll={() => page.setSearchValue('')}
          isLoading={page.isFilterOptionsLoading}
          labels={page.filterPanelLabels}
          rangeLabels={page.filterPanelLabels.rangeLabels}
          extraHiddenItems={extraHiddenItems}
          renderExtraPill={renderExtraPill}
          defaultVisibleExtraIds={defaultVisibleExtraIds}
          onShowExtra={handleShowExtra}
          excludableFieldIds={excludableFieldIds}
          excludedFieldIds={page.excludedFields}
          onToggleExclude={handleToggleExclude}
          excludeLabels={excludeLabels}
        />
        {scopedSupplierId !== null ? (
          <div className="mt-2 flex justify-end">
            <SupplierPhotoZipTrigger
              supplierId={scopedSupplierId}
              canViewPhotos={canDownloadSpecs}
            />
          </div>
        ) : null}
        <InventoryToolbarRow
          leadingSlot={
            page.campaignId != null && page.activeFilterCount > 0 ? (
              <Button
                type="button"
                variant="link"
                size="sm"
                data-testid="save-campaign-preset-btn"
                onClick={() => page.setShowSaveDialog(true)}
              >
                {t('campaign.saveToButton')}
              </Button>
            ) : undefined
          }
          onOpenMap={openMap}
          mapLabel={t('toolbar.mapButton')}
          canEdit={canEdit}
          trashLabel={t('trash.link')}
          showMonthColumns={viewState.showMonthColumns}
          onToggleMonthColumns={() => viewState.setShowMonthColumns(!viewState.showMonthColumns)}
          monthToggleLabel={t('table.availability')}
          columns={page.orderedColumns}
          hiddenColumnIds={page.hiddenColumnIds}
          onToggleColumn={page.toggleColumn}
          columnToggleLabel={t('table.columnVisibility.toggleButton')}
          columnToggleSectionLabel={t('table.columnVisibility.sectionLabel')}
          columnSearchPlaceholder={t('table.columnVisibility.searchPlaceholder')}
          columnNoResults={t('table.columnVisibility.noResults')}
          onMoveColumnUp={page.moveColumnUp}
          onMoveColumnDown={page.moveColumnDown}
          canQuickAddToOffer={canQuickAddToOffer}
          quickAddLabel={headerQuickAddLabel}
          onQuickAdd={openHeaderQuickAdd}
          canImport={page.canImport}
          canImportAvailability={canImportAvailability}
          importMenuLabel={t('toolbar.importMenuButton')}
          importMediaLabel={t('toolbar.importMediaButton')}
          importAvailabilityLabel={t('toolbar.importAvailabilityButton')}
          canCreate={canCreateMediaUnit}
          addButtonLabel={t('toolbar.addButton')}
          onAddNew={openAddForm}
        />
      </div>
      {page.showSaveDialog ? (
        <SaveCampaignDialog
          title={t('campaign.saveDialogTitle')}
          description={t('campaign.saveDialogDescription')}
          cancelLabel={t('filters.cancelLabel')}
          saveLabel={tCommon('actions.saveConfirm')}
          onClose={() => page.setShowSaveDialog(false)}
          onSave={() => page.savePreset()}
        />
      ) : null}
    </>
  );

  if (!canViewInventory) {
    return <UnauthorizedState message={t('permissionDenied')} />;
  }

  if (page.isLoading) return <LoadingSkeleton />;
  if (page.allRows.length === 0)
    return (
      <div className="flex h-full min-h-0 flex-col p-6" data-testid="media-units-page">
        {offerContextBarNode}
        {filterAndToolbarBlock}
        <div className="flex flex-1 items-center justify-center" data-testid="empty-state">
          <p className="text-muted-foreground text-[14px]">
            {resolveEmptyMessage(page.importJobId, hasNarrowedVisibility, t)}
          </p>
        </div>
      </div>
    );

  return (
    <div className="flex h-full min-h-0 flex-col p-6" data-testid="media-units-page">
      {offerContextBarNode}
      {filterAndToolbarBlock}

      <div className="flex min-h-0 flex-1 flex-col">
        {/* Availability sub-toolbar + table: TooltipProvider is scoped tightly to just
            this pair (not the whole page) so every appended RichAvailabilityCell's hover
            tooltip works. AvailabilitySubToolbar is a dedicated slim strip mounted as its
            own sibling row directly above DataTable — not inside MediaInventoryResultsView
            — so toggling the availability control never reflows the filter/results
            toolbar above; it only inserts/removes this one thin row. */}
        <TooltipProvider delayDuration={150}>
          {viewState.showMonthColumns ? (
            <AvailabilitySubToolbar
              granularity={viewState.granularity}
              onGranularityChange={viewState.setGranularity}
              legendItems={availabilityLegendItems}
            />
          ) : null}
          <DataTable
            className="min-h-0 flex-1"
            columns={tableColumns}
            data={page.allRows}
            getRowKey={(item) => String(item.id)}
            getRowTestId={(item) => `inventory-row-${item.id}`}
            renderRowLink={(item) => (
              <RowDetailLink
                to="/media-units/$id"
                params={{ id: String(item.id) }}
                search={{ catalogSearch: encodeCatalogSearch(routeSearch) }}
                ariaLabel={t('table.rowLinkAriaLabel', {
                  id: item.supplierNumber ?? item.grwId,
                })}
                testId={`inventory-detail-link-${item.id}`}
              />
            )}
            sortBy={page.sortBy}
            sortDir={page.sortDir}
            sortOrders={sortOrders}
            onSort={page.handleSort}
            onColumnReorder={page.reorderColumn}
            onColumnResizeEnd={page.setColumnWidth}
            virtualizer={{
              scrollContainerRef: page.scrollContainerRef,
              sentinelRef: page.sentinelRef,
              virtualItems: page.virtualItems,
              totalSize: page.totalSize,
            }}
            footer={
              page.isFetchingNextPage ? (
                <div className="flex w-full justify-center">
                  <div className="h-4 w-4 rounded-full border-2 border-muted-foreground border-t-transparent animate-spin" />
                </div>
              ) : null
            }
          />
        </TooltipProvider>
        {/* Single shared floating toolbar for every bulk-capable action — replaces the
              old below-table standalone buttons that could scroll out of view.
              maxVisibleActions raised from the default 4 to 7: a caller holding every
              permission sees up to 7 actions at once (add-to-offer, bulk-edit,
              bulk-mark-availability, bulk-download-specs, bulk-download-photos,
              bulk-recompute-location, bulk-delete) and none of them should silently
              collapse into the overflow menu. The toolbar itself wraps onto multiple
              centered rows on narrow screens (see @ooh/ui BulkActionToolbar). */}
        {showBulkToolbar ? (
          <BulkActionToolbar
            testId="inventory-bulk-toolbar"
            selectedCount={bulkToolbarSelectedCount}
            visibleCount={bulkToolbarSelectedCount - bulkHiddenCount}
            visibleLabel={(count) => t('quickAdd.visibleCountSuffix', { count })}
            aria-label={t('quickAdd.toolbarAriaLabel')}
            selectedLabel={(count) => t('quickAdd.selectedCountSuffix', { count })}
            moreLabel={t('quickAdd.moreActionsLabel')}
            clearLabel={t('quickAdd.clearSelectionLabel')}
            onClearSelection={bulkClearSelection}
            actions={bulkActions}
            maxVisibleActions={7}
          />
        ) : null}
        {/* Pre-activation "opportunity" state only — once filter-based selection is
              active, the floating toolbar above already shows the full matching count
              and its own clear-selection control. */}
        {canBulkEditAny && !isBulkSelectAllFilterActive ? (
          <SelectAllMatchingBanner
            selectAllFilter={bulkSelectAllFilter}
            selectedCount={bulkSelectedCount}
            totalMatching={page.totalCount}
            onActivateSelectAllFilter={bulkActivateSelectAllFilter}
            onClearSelection={bulkClearSelection}
            t={t}
          />
        ) : null}
        {canBulkMarkAvailability ? (
          <BulkMarkAvailabilityAction
            key={`bulk-mark-availability-${String(bulkMarkAvailabilityOpenKey)}`}
            canBulkMarkAvailability={canBulkMarkAvailability}
            isOpen={isBulkMarkAvailabilityOpen}
            onOpenChange={setIsBulkMarkAvailabilityOpen}
            selectedIds={bulkSelectedIdsArray}
            activeFilters={page.activeFilters}
            totalMatching={page.totalCount}
            hiddenCount={bulkHiddenCount}
          />
        ) : null}
        {canBulkEditMedia ? (
          <BulkEditAction
            key={`bulk-edit-${String(bulkEditOpenKey)}`}
            canBulkEdit={canBulkEditMedia}
            isOpen={isBulkEditDrawerOpen}
            onOpenChange={setIsBulkEditDrawerOpen}
            selectedIds={bulkSelectedIdsArray}
            selectAllFilter={bulkSelectAllFilter}
            totalMatching={page.totalCount}
            hiddenCount={bulkHiddenCount}
            onSuccess={() => {
              setIsBulkEditDrawerOpen(false);
              bulkClearSelection();
            }}
          />
        ) : null}
        {canBulkEditMedia ? (
          <BulkRecomputeLocationAction
            key={`bulk-recompute-location-${String(bulkRecomputeLocationOpenKey)}`}
            canBulkEdit={canBulkEditMedia}
            isOpen={isBulkRecomputeLocationOpen}
            onOpenChange={setIsBulkRecomputeLocationOpen}
            selectedIds={bulkSelectedIdsArray}
            selectAllFilter={bulkSelectAllFilter}
            totalMatching={page.totalCount}
            hiddenCount={bulkHiddenCount}
            onSuccess={() => {
              setIsBulkRecomputeLocationOpen(false);
              bulkClearSelection();
            }}
          />
        ) : null}
        {canDeleteMedia ? (
          <BulkDeleteAction
            key={`bulk-delete-${String(bulkDeleteOpenKey)}`}
            canDelete={canDeleteMedia}
            isOpen={isBulkDeleteOpen}
            onOpenChange={setIsBulkDeleteOpen}
            selectedIds={bulkSelectedIdsArray}
            selectAllFilter={bulkSelectAllFilter}
            totalMatching={page.totalCount}
            hiddenCount={bulkHiddenCount}
            onSuccess={() => {
              setIsBulkDeleteOpen(false);
              bulkClearSelection();
            }}
          />
        ) : null}
        {bulkDownloadManifest ? (
          <BulkDownloadConfirmDialog
            manifest={bulkDownloadManifest}
            totalSelectedUnits={bulkSelectedIdsArray.length}
            onConfirm={() => void confirmBulkDownload()}
            onCancel={cancelBulkDownload}
          />
        ) : null}
        <div className="flex items-center justify-between px-4 py-3 border-t border-border/40 bg-muted/20 text-[12px] text-muted-foreground">
          <span data-testid="footer-count">
            {t('footer.shown')} {page.allRows.length.toLocaleString('pl-PL')} {t('footer.of')}{' '}
            {page.totalCount.toLocaleString('pl-PL')} {t('footer.units')}
          </span>
        </div>
      </div>
      {/* Unified SELECT popover (task 4.5) — renders for the active multi-cell selection,
          which handleInventoryCellClick/handleInventoryCellMouse* already filter to
          SELECT-eligible cells (free/option-own/reserved-own). */}
      {multiSelection && multiSelection.cells.length > 0 ? (
        <UnifiedSelectPopover
          selection={multiSelection}
          resolveCell={resolveInventoryMultiSelectCell}
          anchorRef={multiSelectAnchorRef}
          resolveMediaUnitLabel={(id) => page.seenRowsById.get(id)?.grwId}
          offerPicker={
            <QuickAddOfferPickerCompactTrigger
              drafts={drafts}
              selectedDraftId={selectedDraftId}
              draftUnitLabel={pickerLabels.draftUnitLabel}
              draftSummarySeparator={pickerLabels.draftSummarySeparator}
              changeSelectionLabel={pickerLabels.changeSelectionLabel}
              pickOfferLabel={t('quickAdd.picker.pickOfferLabel')}
              onOpenPicker={() => setIsSelectOfferPickerOpen(true)}
            />
          }
          chosenOfferId={chosenOffer?.id ?? preselectedOfferId}
          suppressOutsideDismiss={isSelectOfferPickerOpen}
          onClear={clearMultiSelection}
          onBatchReserveSuccess={handleInventoryBatchReserveSuccess}
          onBatchReleaseSuccess={handleInventoryBatchReleaseSuccess}
          queueJoinSection={catalogSelectQueueJoinSection}
          queueJoinLoading={isCatalogSelectQueueLoading}
        />
      ) : null}
      {isSelectOfferPickerOpen ? (
        <QuickAddOfferPicker
          {...pickerLabels}
          presentation="modal"
          initialMode="changing"
          mediaUnitIds={[]}
          subtitle={t('quickAdd.picker.subtitle')}
          drafts={drafts}
          selectedDraftId={selectedDraftId}
          onSelectDraft={setSelectedDraftId}
          clientOptions={clientOptions}
          salesUsers={salesUsers}
          authUserId={auth.user?.id}
          canAssignOtherSalesperson={canAssignOtherSalesperson}
          canCreateClient={canCreateClient}
          campaignNumberPreview={campaignNumberPreview}
          onCampaignNumberPreviewInputChange={setCampaignNumberPreviewInput}
          createDraftMode="inline"
          initialDefaultDateFrom={calendarPickerDefaultRange?.from ?? null}
          initialDefaultDateTo={calendarPickerDefaultRange?.to ?? null}
          confirmExistingLabel={t('quickAdd.picker.confirmExistingLabel')}
          confirmNewLabel={t('quickAdd.picker.confirmNewLabel')}
          isCalendarSelectionContext
          onConfirm={handleCalendarPickerConfirm}
          onCancel={() => setIsSelectOfferPickerOpen(false)}
          onOpenFullForm={(args) => {
            setIsSelectOfferPickerOpen(false);
            clearMultiSelection();
            openFullForm({ ...args, mediaUnitIds: calendarPickerMediaUnitIds });
          }}
        />
      ) : null}
      {isPickerOpen ? (
        <QuickAddOfferPicker
          {...pickerLabels}
          presentation="modal"
          mediaUnitIds={pickerMediaUnitIds}
          subtitle={t('quickAdd.subtitle', { count: pickerCount })}
          drafts={drafts}
          selectedDraftId={selectedDraftId}
          onSelectDraft={setSelectedDraftId}
          clientOptions={clientOptions}
          salesUsers={salesUsers}
          authUserId={auth.user?.id}
          canAssignOtherSalesperson={canAssignOtherSalesperson}
          canCreateClient={canCreateClient}
          campaignNumberPreview={campaignNumberPreview}
          onCampaignNumberPreviewInputChange={setCampaignNumberPreviewInput}
          createDraftMode="inline"
          lockedTarget={offerContext}
          confirmExistingLabel={t('quickAdd.confirmExistingWithCount', { count: pickerCount })}
          confirmNewLabel={t('quickAdd.confirmNewWithCount', { count: pickerCount })}
          onConfirm={confirm}
          onNavigateToNewOffer={navigateToNewOffer}
          onSuccess={() => {
            bulkClearSelection();
            setIsPickerOpen(false);
          }}
          onCancel={() => setIsPickerOpen(false)}
          onOpenFullForm={(args) => {
            setIsPickerOpen(false);
            openFullForm(args);
          }}
        />
      ) : null}
      {page.photoPreviewUnitId != null && page.photoPreviewPhotos.length > 0 ? (
        <DetailPhotoLightbox
          photos={page.photoPreviewPhotos}
          activeIndex={page.photoPreviewActiveIndex}
          onClose={page.closePhotoPreview}
          onNavigate={page.setPhotoPreviewActiveIndex}
          labels={{
            close: t('detail.lightbox.close'),
            previous: t('detail.lightbox.previous'),
            next: t('detail.lightbox.next'),
            counter: (current, total) => t('detail.lightbox.counter', { current, total }),
          }}
        />
      ) : null}
    </div>
  );
}
